import script from "./DebriefsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DebriefsTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__